var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "star-fill",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19 19",
    style: {
      enableBackground: "new 0 0 19 19"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "outerLine",
    d: "M4.4,16.4c-0.1,0.4,0.4,0.8,0.7,0.6l4.4-2.3l4.4,2.3c0.4,0.2,0.8-0.1,0.7-0.6l-0.8-4.7l3.5-3.4C17.6,8,17.5,7.4,17,7.4 l-4.9-0.7L10,2.3C9.8,2,9.5,1.9,9.3,2C9.2,2.1,9.1,2.2,9,2.3L6.9,6.6L2,7.3C1.5,7.4,1.3,8,1.7,8.3l3.5,3.4L4.4,16.4L4.4,16.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "starFill",
    d: "M4.4,16.4c-0.1,0.4,0.4,0.8,0.7,0.6l4.4-2.3l4.4,2.3c0.4,0.2,0.8-0.1,0.7-0.6l-0.8-4.7l3.5-3.4C17.6,8,17.5,7.4,17,7.4 l-4.9-0.7L10,2.3C9.8,2,9.5,1.9,9.3,2C9.2,2.1,9.1,2.2,9,2.3L6.9,6.6L2,7.3C1.5,7.4,1.3,8,1.7,8.3l3.5,3.4L4.4,16.4L4.4,16.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFill);
export default __webpack_public_path__ + "static/media/star-fill.685337ee8eb99274c88e2bc8c6783e09.svg";
export { ForwardRef as ReactComponent };